module.exports = __webpack_public_path__ + "static/media/LivWeb_GraceBeck-18.3d8be293.JPG";